import useRestList from "../../_shared/hooks/useRestList";
import { useEffect, useState } from "react";
import "./layoutCombination.css";
import HandIcon from "../../../assets/images/icons/push.svg";
import YellowButton from "../../../assets/images/icons/Pulsante_lay.png";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import ReactHtmlParser from "react-html-parser";
import { Navigate, redirect, useParams } from "react-router-dom";

import AppButton from "../../_shared/components/AppButton";
import BackIcon from "../../_shared/components/BackIcon";
import AppText from "../../_shared/components/AppText";
import HtmlText from "../../_shared/components/HtmlText";
import SlideImages from "../../_shared/components/SlideImages";
import CloseIcon from "../../_shared/components/CloseIcon";
import SideMenu from "../../_shared/components/SideMenu";

export default function LayoutCombinations(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const [elements] = useRestList("/elementcompositions");
  const [products] = useRestList("/products");
  const [rooms] = useRestList("/rooms");
  const [videos] = useRestList("/videos", null, { pageSize: 100 });

  const { id } = useParams();

  const [layout, setLayout] = useState();

  useEffect(() => {
    rooms.map(
      (room) =>
        room.layouts.some((x) => x?._id === id) &&
        setLayout(room.layouts.find((x) => x?._id === id))
    );
  }, [id, rooms]);

  const [openedElement, setOpenedElement] = useState();
  const [selectedComposition, setSelectedComposition] = useState();
  const [showModalComposition, setShowModalComposition] = useState();

  const [selectedIndexImage, setSelectedIndexImage] = useState(0);
  const [elementIsAProduct, setElementIsAProduct] = useState(false);

  const [selectedVideo, setSelectedVideo] = useState();
  const [openedVideo, setOpenedVideo] = useState();

  useEffect(() => {
    selectedVideo
      ? setOpenedVideo(videos.find((x) => x.id === selectedVideo))
      : setOpenedVideo();
  }, [selectedVideo]);

  function printCompositionsName() {
    return (
      <div className="rowCenter">
        {layout?.compositions?.map((comp) => {
          return (
            <div
              className="compName"
              onClick={() => setSelectedComposition(comp)}
            >
              {selectedComposition?.code === comp?.code ? (
                <div className="compositionTextSelected">{comp?.code}</div>
              ) : (
                <div className="compositionText">{comp?.code}</div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  function renderImage() {
    // console.log("opened element", selectedComposition);
    return (
      <Navigate to={`/composition-image/${selectedComposition?.id}`}></Navigate>
    );
  }
  function renderElements() {
    return (
      <div>
        <div className="row">
          <div>
            <BackIcon></BackIcon>
          </div>
          <div>
            <AppText bold>{layout?.layoutName?.it}</AppText>
            <AppText>{layout?.layoutName?.en}</AppText>
          </div>
        </div>
        {!selectedComposition && (
          <div
            style={{
              background: `url(${layout?.defaultCompositionImage})`,
            }}
            className="imageLayComposition"
          />
        )}
        {selectedComposition && (
          <div
            style={{
              background: `url(${selectedComposition?.image})`,
            }}
            key={selectedComposition._id}
            className="imageLayComposition animate-delay1"
          >
            <div
              style={{
                position: "absolute",
                top: `${
                  layout?.pickPointDefaultComposition?.percentageX ?? 70
                }%`,
                left: `${
                  layout?.pickPointDefaultComposition?.percentageX ?? 75
                }%`,
              }}
            >
              <div
                className="clickCard"
                onClick={() => setShowModalComposition(true)}
              >
                <img
                  alt=""
                  src={HandIcon}
                  style={{
                    height: 70,
                    width: 150,
                  }}
                  className="animate-pulse"
                ></img>

                <AppText
                  style={{
                    textAlign: "right",
                    width: 132,
                  }}
                  small
                  bold
                >
                  Scopri di più
                </AppText>
                <AppText
                  style={{
                    textAlign: "right",

                    width: 130,
                  }}
                  light
                  small
                >
                  Find out more
                </AppText>
              </div>
            </div>
          </div>
        )}
        <div className="rowCenter">
          <AppText bold>Scegli la composizione</AppText>
          <AppText light> / Choose your room</AppText>
        </div>
        {printCompositionsName()}
      </div>
    );
  }

  return openedVideo ? (
    <div>
      <CloseIcon onClick={() => setSelectedVideo()} />
      <video
        autoPlay
        src={openedVideo?.video}
        width="100%"
        height="100%"
        controls
      />
    </div>
  ) : (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        <div> {showModalComposition ? renderImage() : renderElements()}</div>
      </div>
    </div>
  );
}
